var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcCamera = function SvgIcCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#286DF0",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7428 9.51803C11.7992 9.40487 11.9147 9.33334 12.0412 9.33334H15.9588C16.0852 9.33334 16.2008 9.40487 16.2571 9.51803L16.8294 10.6667H19.6667C19.8508 10.6667 20 10.8159 20 11V18.3333C20 18.5174 19.8508 18.6667 19.6667 18.6667H8.33333C8.14924 18.6667 8 18.5174 8 18.3333V11C8 10.8159 8.14924 10.6667 8.33333 10.6667H11.1705L11.7428 9.51803ZM16 14.6668C16 15.7713 15.1046 16.6668 14 16.6668C12.8954 16.6668 12 15.7713 12 14.6668C12 13.5622 12.8954 12.6668 14 12.6668C15.1046 12.6668 16 13.5622 16 14.6668Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/ic_camera.f8f7a88b.svg";
export { ForwardRef as ReactComponent };